import { render, staticRenderFns } from "./viewSharedLink.vue?vue&type=template&id=12c0c03a&scoped=true"
import script from "./viewSharedLink.vue?vue&type=script&lang=js"
export * from "./viewSharedLink.vue?vue&type=script&lang=js"
import style0 from "./viewSharedLink.vue?vue&type=style&index=0&id=12c0c03a&prod&lang=css"
import style1 from "./viewSharedLink.vue?vue&type=style&index=1&id=12c0c03a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0c03a",
  null
  
)

export default component.exports